// Shared topic -> visual mapping for the Support & FAQ redesign preview.
// Used by both Home.vue (topic grid) and Topic.vue (topic header) so a
// given Zendesk section always gets the same image/icon wherever it shows up.
//
// Each entry can be either a plain image path (string) or an object with:
//   src      — the image (required)
//   position — CSS object-position, e.g. "center top", "50% 30%" (default: "center")
//   size     — CSS object-fit override, e.g. "contain" (default: "cover")
//   scale    — a CSS transform scale, e.g. "0.8" — useful for logos/illustrations
//              that need to appear smaller within the frame (default: none)

const TOPIC_ICONS = ["circle", "chart", "card", "doc", "trend", "badge"];

const TOPIC_IMAGES = {
  // Participant sections
  52548766439955: {
    src: require("@/assets/supportPortal/RMR-computer.png"),
    position: "50% 65%"
  }, // Getting Started & Account Access
  52548042890515: {
    src: require("@/assets/supportPortal/person-holding-rmr-card.png"),
    size: "cover",
    position: "50% 70%",
    scale: "1.0"
  }, // Debit Cards & Mobile Wallet
  52658101803539: require("@/assets/transit.jpg"), // Parking (PRK) and Transit (TRN) Accounts
  52550364387219: require("@/assets/supportPortal/doctor-holding-cash.jpg"), // Flexible Spending (FSA) and Limited Purpose (LPF)
  52550330859411: require("@/assets/supportPortal/coins-and-receipt.jpg"), // Claims, Receipts & Reimbursements
  52550341434003: require("@/assets/supportPortal/wedding-newborn-job.png"), // Life Events & Employment Changes
  360003418314: require("@/assets/dca.jpg"), // Dependent Care Account (DCA)
  360003792274: {
    src: require("@/assets/supportPortal/doctor-with-patient.jpg"),
    size: "cover",
    position: "70% 75%",
    scale: "1.0"
  }, // COBRA
  360003445833: require("@/assets/supportPortal/savings-jar.jpg"), // Health Savings Account (HSA)
  360004874393: require("@/assets/supportPortal/cash-paperwork.jpg"), // HRA and Lifestyle Spending (LSA)
  // Employer sections
  360007343773: require("@/assets/hra.jpg"), // Employer FAQ
  360007330433: require("@/assets/hsa.jpg"), // Onboarding
  360006870753: require("@/assets/supportPortal/conference.jpg"), // FLEX/CDH Portal
  21329933197331: require("@/assets/supportPortal/discussion.jpg"), // Non-discrimination Testing
  35656555225491: require("@/assets/fsa.jpg") // Offboarding
};

function normalizeVisual(entry) {
  if (!entry) return null;
  if (typeof entry === "string")
    return { src: entry, position: "center", size: "cover", scale: null };
  return { position: "center", size: "cover", scale: null, ...entry };
}

export function imageForSection(id) {
  return normalizeVisual(TOPIC_IMAGES[id]);
}

// Deterministic per-section icon (rather than list-index based) so a topic
// always gets the same icon regardless of what order it renders in.
export function iconForSection(id) {
  return TOPIC_ICONS[id % TOPIC_ICONS.length];
}
